import { TrackingAction, TrackingContext } from 'src/boot/plausible'
import { AbstractEntity } from 'src/entities/AbstractEntity'
import { RouteLocationRaw } from 'vue-router'
import { ROUTE_NAME_VIEW } from 'src/router/routes'
import { useCommonStore } from 'stores/common-store'

export class SectorEntity extends AbstractEntity {
  // FIXME: Set default icon for sectors
  protected readonly defaultIcon: string = 'spi-building'

  public getNameFromInventory (): string {
    return useCommonStore().getSectorNameById(this.id) || ''
  }

  public getIcon (): string {
    return useCommonStore().getSectorIconById(this.id) || this.defaultIcon
  }

  public getSubType (): string {
    return ''
  }

  public getTrackingAction (): TrackingAction {
    return TrackingAction.OPEN_VIEW
  }

  public getTrackingContext (): TrackingContext {
    return { sectorName: this.getName(), sectorId: this.id }
  }

  public getRouteOptions (): RouteLocationRaw {
    return { name: ROUTE_NAME_VIEW, query: { sector: [this.id] } }
  }
}
